import {config} from '../config';

export default {
    getWelcomePwaTipsIcons: () => config.data.welcomePwa?.tipsIcons,
    getWelcomePwaThumbnailSrc: () => config.data.welcomePwa?.thumbnailSrc,
    getWelcomePwaVideoSrc: () => config.data.welcomePwa?.videoSrc,
    getWelcomePwaImageSrc: () => config.data.welcomePwa?.imageSrc,
    getWelcomePwaButtonLink: () => config.data.welcomePwa?.buttonLink,
};
